import Axios from "../../../axios";
import {rosterConstants} from "../../../constants/ApiConstant";

export async function addRoster(params) {
    return Axios.post(rosterConstants.ROSTER_SAVE, params);
}

export async function searchRoster(params) {
    return Axios.post(rosterConstants.ROSTER_SEARCH, params);
}

export async function deleteRoster(params) {
    return Axios.post(rosterConstants.ROSTER_DELETE, params);
}
